import { render, staticRenderFns } from "./HistorialCortesiasEventos.vue?vue&type=template&id=53c99456"
import script from "./HistorialCortesiasEventos.vue?vue&type=script&lang=js"
export * from "./HistorialCortesiasEventos.vue?vue&type=script&lang=js"
import style0 from "./HistorialCortesiasEventos.vue?vue&type=style&index=0&id=53c99456&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports